module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("74sTQ"))).then(() => module.bundle.root('gtEzC'));